import { UniversalIrEngine } from './framework/UniversalIrEngine';
export class SonosArc extends UniversalIrEngine {
    constructor() {
        super(...arguments);
        this.irRepeat = 1;
        // From Global Cache IR Database file: Sonos Arc - Set #: 7464'
        this.irConfig = {
            type: 'audioDsp',
            operations: {
                volumeDown: `,1,38000,${this.irRepeat},69,347,173,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,65,22,65,22,22,22,22,22,65,22,65,22,22,22,65,22,65,22,22,22,22,22,22,22,65,22,22,22,22,22,22,22,65,22,65,22,65,22,65,22,22,22,65,22,65,22,65,22,22,22,1613,347,87,22,3692`,
                volumeMuteToggle: `,1,38000,${this.irRepeat},69,347,173,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,65,22,65,22,22,22,22,22,65,22,65,22,22,22,65,22,65,22,22,22,22,22,65,22,65,22,22,22,22,22,22,22,65,22,65,22,65,22,22,22,22,22,65,22,65,22,65,22,22,22,1613,347,87,22,3692`,
                volumeUp: `,1,38000,${this.irRepeat},69,347,173,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,65,22,65,22,22,22,22,22,65,22,65,22,22,22,65,22,65,22,22,22,65,22,22,22,65,22,22,22,22,22,22,22,65,22,65,22,22,22,65,22,22,22,65,22,65,22,65,22,22,22,1613,347,87,22,3692`,
                // Other codes not yet supported:
                // inputScroll: `,1,38000,${this.irRepeat},69,347,173,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,65,22,65,22,22,22,22,22,65,22,65,22,22,22,65,22,65,22,22,22,65,22,65,22,22,22,22,22,22,22,22,22,65,22,65,22,22,22,22,22,65,22,65,22,65,22,65,22,22,22,1613,347,87,22,3692`,
            },
        };
    }
}
SonosArc.key = '-N1il6ktYC7NmZsOxyl3';
